export default [
    {
        "id": "offline",
        "html": require('./offline/html').default
    }
]